export const pluralise = (count, word, suffix = 's') =>
    `${word}${count !== 1 ? suffix : ''}`;

export const boolToYesNo = (isTrue) => {
    if (isTrue === null) return null;
    return isTrue ? 'Yes' : 'No';
};
